module.exports = __webpack_public_path__ + "media/stylesheets/images/media/service_kurashino-223ddf25c1b4be1a6bbaf8486d6f7a0e.png";